import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import CTOCategories from "./cto-categories/CTOCategories";
import CTOHead from "./cto-heads/CTOHead";
import {
  fetchCtoCategoriesData,
  fetchCtoHeadsData,
} from "../../redux/reducers/apiSlice";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";

const CTOHeadCategoryTabs = ({ userInfoData, onCloseModal }) => {
  const dispatch = useDispatch();

  function getCTOCategories(filters = {}) {
    dispatch(
      fetchCtoCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getCTOHeads(filters = {}) {
    dispatch(
      fetchCtoHeadsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getCTOCategories();
    getCTOHeads();
  }, []);

  return (
    <>
      <ModalHeadAndClose
        title="Manage CTO Categories and Heads"
        onClose={onCloseModal}
        isReload={() => {
          getCTOCategories();
          getCTOHeads();
        }}
      />

      <div className="cupon-requests-tabs cto-category-head mt30">
        <Tabs
        // selectedIndex={selectedTab} onSelect={handleTabSelect}
        >
          <TabList>
            <Tab>CTO Categories</Tab>
            <Tab>CTO Head</Tab>
          </TabList>

          <TabPanel>
            <CTOCategories
              userInfoData={userInfoData}
              callFunction={getCTOCategories}
            />
          </TabPanel>
          <TabPanel>
            <CTOHead userInfoData={userInfoData} callFunction={getCTOHeads} />
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default CTOHeadCategoryTabs;
